import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    //redirect: '/index.xhtml'
    component: () => import ('../views/Impressum.vue')
  },
  {
    path: '/index',
    component: () => import ('../views/Impressum.vue')
  },
  {
    path: '/index.html',
    component: () => import ('../views/Impressum.vue')
  },
  {
    path: '/index.xhtml',
    component: () => import ('../views/Impressum.vue')
  },
  {
    path: '/impressum.xhtml',
    component: () => import ('../views/Impressum.vue')
  },
  {
    path: '/datenschutz.xhtml',
    component: () => import ('../views/Datenschutz.vue')
  },
  {
    path: '/servicedesk.xhtml',
    component: () => import ('../views/ServiceDesk.vue')
  },
  {
    path: '/webmail.xhtml',
    component: () => import ('../views/Webmail.vue')
  },
  {
    path: '/:notfound',
    component: () => import ('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
